import contains from './contains';
import values from './values';
export default (function (obj, value) {
  return contains(values(obj), value);
});